const Footer =() => {

    return(
        <>
            <div className="footer footer_container">
                <div className="footer_content">
                    <div className="footer_head">
                        
                        <h1>Footer</h1>
                    </div>
                    <div className="footer_body">
                        
                        <h2>body</h2>
                    </div>
                    <div className="footer_footer">
                        
                        <h2>footer</h2>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Footer;